import { useEffect, useState } from "react";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const anchor = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <footer className="border-t border-background-200 bg-background-100">
        <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-14">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500">
                  <i className="ri-water-flash-line text-lg text-background-50"></i>
                </span>
                <span className="font-display text-2xl font-black text-primary-600">吃瓜快手</span>
              </div>
              <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
                全网最有才的吃瓜群众都在这里。神回复、沙雕段子、梗图表情包聚合社区，看热闹更要看评论。
              </p>
              <div className="mt-5 flex gap-2">
                {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-tiktok-fill"].map((icon, i) => (
                  <a
                    key={i}
                    href="#newsletter"
                    aria-label="关注我们"
                    onClick={(e) => e.preventDefault()}
                    className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-500 transition-colors hover:border-primary-200 hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={`${icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-900">内容导航</h4>
              <ul className="mt-4 space-y-3">
                {[
                  { id: "comments", label: "今日神回复" },
                  { id: "memes", label: "梗图表情包" },
                  { id: "rank", label: "吃瓜热度榜" },
                  { id: "about", label: "关于我们" },
                ].map((l, i) => (
                  <li key={i}>
                    <a
                      href={`#${l.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        anchor(l.id);
                      }}
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-900">帮助与联系</h4>
              <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                <li>
                  <a
                    href="#faq"
                    onClick={(e) => {
                      e.preventDefault();
                      anchor("faq");
                    }}
                    className="cursor-pointer transition-colors hover:text-primary-600"
                  >
                    常见问题
                  </a>
                </li>
                <li>
                  <a href="mailto:hi@guakuaishou.example.com" className="cursor-pointer transition-colors hover:text-primary-600">
                    hi@guakuaishou.example.com
                  </a>
                </li>
                <li>
                  <a href="#newsletter" onClick={(e) => { e.preventDefault(); anchor("newsletter"); }} className="cursor-pointer transition-colors hover:text-primary-600">
                    投稿 / 合作
                  </a>
                </li>
                <li>
                  <a href="#faq" onClick={(e) => { e.preventDefault(); anchor("faq"); }} className="cursor-pointer transition-colors hover:text-primary-600">
                    举报与规则
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} 吃瓜快手 · 快乐有梗，友善吃瓜。保留所有权利。
            </p>
            <p className="text-xs text-foreground-400">用最少的屏幕时间，刷到最多的快乐。</p>
          </div>
        </div>
      </footer>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-all hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </>
  );
}